import Gallery from 'vue-gallery';
import axios from 'axios';
import URLS from '../../util/urls.js';

import { Money } from "v-money";
import { mapActions, mapState } from "vuex";

import AppGravarVistoriaDialog from "./dialogs/GravarVistoriaDialog.vue";
import AppAlterarVencimentoDialog from "./dialogs/AlterarVencimentoDialog.vue";
import AppResumoFinanceiroDialog from "./dialogs/ResumoFinanceiroDialog.vue";
import AppAlterarReajusteRenovacaoDialog from "./dialogs/AlterarReajusteRenovacaoDialog.vue"
import AppGerarDimobDialog from "./dialogs/GerarDimobDialog.vue";
import AppReajustarAluguelDialog from "./dialogs/ReajustarAluguelDialog.vue";
import AppRenovarContratoDialog from "./dialogs/RenovarContratoDialog.vue";
import AppProrrogarAluguelDialog from "./dialogs/ProrrogarAluguelDialog.vue";
import AppAlterarCarenciaDialog from "./dialogs/AlterarCarenciaDialog.vue";
import AppAlterarTaxaAdmDialog from "./dialogs/AlterarTaxaAdmDialog.vue";
import AppAlterarValorDialog from "./dialogs/AlterarValorDialog.vue";
import AppAlterarRenovacaoDialog from "./dialogs/AlterarRenovacaoDialog.vue";
import AppAdicionarDescontoDialog from "./dialogs/AdicionarDescontoDialog.vue";
import AppAdicionarBoletoDialog from "./dialogs/AdicionarBoletoDialog.vue";
import AppAdicionarLancamentoDialog from "./dialogs/AdicionarLancamentoDialog.vue";
import AppGerarBoletoAvulsoDialog from "./dialogs/GerarBoletoAvulsoDialog.vue";
import AppProrrogarBoletoAvulsoDialog from "./dialogs/ProrrogarBoletoAvulsoDialog.vue";
import AppDesocuparDialog from './dialogs/DesocuparDialog.vue';
import AppFinalizarAluguelDialog from './dialogs/FinalizarAluguelDialog.vue';

import AppGravarClienteDialog from "../../shared/dialogs/GravarClienteDialog.vue";
import AppUploadArquivoDialog from "../../shared/dialogs/UploadArquivoDialog.vue";
import AppCriarDiretorioDialog from "../../shared/dialogs/CriarDiretorioDialog.vue";
import AppSelecionarDiretorioDialog from "../../shared/dialogs/SelecionarDiretorioDialog.vue";
import AppPerguntasFormularioDialog from "../../shared/dialogs/PerguntasFormularioDialog.vue";
import AppGravarObservacaoDialog from "../../shared/dialogs/GravarObservacaoDialog.vue";
import AppSelecionarContaBancariaDialog from "../../shared/dialogs/SelecionarContaBancariaDialog.vue";
import AppGerarEnviarEmailDialog from "../../shared/dialogs/GerarEnviarEmailDialog.vue";
import AppGerarBoletosEmAbertoDialog from "./dialogs/GerarBoletosEmAbertoDialog.vue";
import AppCriarDiretorioArquivoDialog from "../../shared/dialogs/CriarDiretorioArquivoDialog.vue";
import AppSelecionarDiretorioArquivoDialog from "../../shared/dialogs/SelecionarDiretorioArquivosDialog.vue";  
import AppTrocaTitularidadeDialog from "./dialogs/TrocaTitularidade.vue";
import AppDesfazerTrocaTitularidadeDialog from './dialogs/DesfazerTrocaTitularidade.vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolder, faFile } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFolder,faFile,faFileUpload)

import Util from "../../util/funcoes.js";
import { BANCOS, ESTADOS } from "../../util/constantes"
import {
  STATUS_CONTRATO_ALUGUEL,
  TIPO_ITEM_RECIBO ,
  STATUS_RECIBO_REPASSE,
  TIPO_VISTORIA,
  STATUS_VISTORIA,
  ESTADO_VISTORIA,
  FORMA_ALUGUEL,
  TIPO_LOCACAO,
  TIPO_ALUGUEL,
  INDICE_REAJUSTE,
  FORMA_PAGAMENTO_SEGURO_INCENDIO,
  REGRA_REPASSE,
  TIPO_GARANTIA,
  TIPO_GARANTIA_PESQUISA,
  TIPO_BOLETO,
  PERIDIOCIDADE_ALUGUEL,
  CATEGORIA_CLIENTE
} from "../../util/constantes.js";
import { faFileUpload } from '@fortawesome/free-solid-svg-icons';

//var BigDecimal = require("js-big-decimal");

export default { 
  components: {
    AppGravarVistoriaDialog,
    AppAlterarVencimentoDialog,
    AppResumoFinanceiroDialog,
    AppGerarDimobDialog,
    AppReajustarAluguelDialog,
    AppRenovarContratoDialog,
    AppProrrogarAluguelDialog,
    AppAlterarCarenciaDialog,
    AppAlterarTaxaAdmDialog,
    AppAlterarValorDialog,
    AppAlterarRenovacaoDialog,
    AppAdicionarDescontoDialog,
    AppAdicionarBoletoDialog,
    AppAdicionarLancamentoDialog,
    AppDesocuparDialog,
    AppFinalizarAluguelDialog,
    AppAlterarReajusteRenovacaoDialog,

    AppCriarDiretorioDialog,
    AppSelecionarDiretorioDialog,
    AppPerguntasFormularioDialog,
    AppUploadArquivoDialog,
    AppGravarClienteDialog,
    AppGravarObservacaoDialog,
    AppSelecionarContaBancariaDialog,
    AppGerarBoletoAvulsoDialog,
    AppProrrogarBoletoAvulsoDialog,
    AppGerarEnviarEmailDialog,
    AppGerarBoletosEmAbertoDialog,
    AppCriarDiretorioArquivoDialog,
    AppSelecionarDiretorioArquivoDialog,
    AppTrocaTitularidadeDialog,
    AppDesfazerTrocaTitularidadeDialog,

    FontAwesomeIcon,

    Gallery,
    Money
  },
  data() {
    return {
      infiniteLoadingId: 0,

      //somente para visualização
      formaPagamentoIptu: [
        {label:"À vista", data:"A_VISTA"},
        {label:"Parcelado", data:"PARCELADO"}],
      formaIptu: "A_VISTA",
      tiposContratos: [
        {label: "Todos", data: undefined},
        {label: "Não Coligado", data: "NAO_COLIGADO"},
        {label: "Coligado ao Grupo", data: "COLIGADO"}
      ],
      
      tabKey: 0,
      tabSelecionada: "detalhes",
      loadingUsuarios: false,
      loadingClientes: false,
      loadingImoveis: false,
      loadingFiadores: false,

      isVisibleFiltrosAdicionais: false,

      fiadoresDisponiveis: [],

      exibirVistoriasCanceladas: false,

      contasDisponiveisImobiliaria: [],

      observacaoSelecionada: {},
      observacaoEmEdicao: undefined,
      formularioSelecionado: {
        perguntasFormulario: []
      },

      fiadorSelecionado: undefined,
      vistoriaSelecionada: {},
      comodoSelecionado: {
        imagens: []
      },

      filtroObservacoes: '',

      imagensViewerId: 0,
      imagemSelecionada: null,
      
      visibilidadeDialogGravarVistoria: false,
      visibilidadeAlterarVencimentoDialog: false,
      visibilidadeResumoFinanceiroDialog: false,
      visibilidadeGerarDimobDialog: false,
      visibilidadeReajustarAluguelDialog: false,
      visibilidadeRenovarContratoDialog: false,
      visibilidadeProrrogarAluguelDialog: false,
      visibilidadeAlterarCarenciaDialog: false,
      visibilidadeAlterarTaxaAdmDialog: false,
      visibilidadeAlterarValorDialog: false,
      visibilidadeAlterarRenovacaoDialog: false,
      visibilidadeAdicionarDescontoDialog: false,
      visibilidadeAdicionarBoletoDialog: false,
      visibilidadeAdicionarLancamentoDialog: false,
      visibilidadeAlterarReajusteRenovacao: false,

      visibilidadeCriarDiretorioDialog: false,
      visibilidadeSelecionarDiretorioDialog: false,
      visibilidadePerguntasFormularioDialog: false,
      visibilidadeUploadArquivoDialog: false,
      visibilidadeGravarClienteDialog: false,
      visibilidadeGravarFiadorDialog: false,
      visibilidadeGravarObservacaoDialog: false,
      visibilidadeSelecionarContaRepasseDialog: false,
      visibilidadeSelecionarContaImobiliariaDialog: false,
      visibilidadeGerarBoletoDialog: false,
      visibilidadeProrrogarBoletoAvulsoDialog: false,
      visibilidadeGerarEnviarRelatorioDialog: false,
      visibilidadeGerarEnviarFichaCadastralDialog: false,
      visibilidadeDesocuparDialog: false,
      visibilidadeFinalizarAluguelDialog: false,
      visibilidadeGerarBoletosEmAbertoDialog: false,
      visibilidadeTrocaTitularidadeDialog: false,
      visibilidadeDesfazerTrocaTitularidadeDialog: false,

      tipoVistoriaSelecionada: '',
      clienteContaRepasse: undefined,
      contaImobiliariaSelecionada: undefined,
      boletoAvulsoSelecionado: undefined,

      visibilidadeCriarDiretorioDialogArquivo: false,
      visibilidadeSelecionarDiretorioArquivoDialog: false,

      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "R$ ",
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false,
        min: 0.0,
        max: 100
      },

      percentAM: {
        decimal: ",",
        thousands: ".",
        suffix: " % a.m.",
        precision: 2,
        masked: false,
        min: 0.0,
        max: 100
      },

      defaultProps: {
        label: "nome",
        children: "formularios"
      },

      vistoriaProps: {
        label: "nome"
      },

      auxContaBancaria: {
        id: 0
      },

      validacao: {
        imovel: [
          { type: "object", required: true,
            fields: {
              id: {type: "number", required: true, min: 1 }
            }
          }
        ],
        locatario: [
          { type: "object", required: true,
            fields: {
              id: {type: "number", required: true, min: 1 }
            }
          }
        ],
        duracao: [
          { required: true, trigger: 'blur'},
          { validator: this.validarDuracao}
        ],
        reajuste: [{ required: true }],
        regraRepasse: [{ required: true }],
        formaAluguel: [{ required: true }],
        tipoAluguel: [{ required: true }],
        tipoLocacao: [{ required: true }],
        dataInicio: [{ required: true }],
        dataPrimeiroVencimento: [{ required: true }],
        valor: [{ type: "number", required: true, min: 0.1 }],
        comissao: [{ type: "number", min: 0.0, max: 100 }],
        formaPagamentoSeguroIncendio: [{ required: true }],
        dataRescisao: [{ required: true }]
      },
      pesquisaBoletosAvulsos: {
        nomeCliente: undefined,
        tipoBoleto: undefined
      },

      arquivoSelecionado: undefined,
      arquivosProps: {
        label: "nome",
        children: "arquivos"
      },
      keysArquivo: ["usuario","descricao","data","localizacaoFisica", "extensao"],
      configurarAprovado: false,
      hoverAlterarReajuste: false,
      hoverAlterarAprovado: false,
      hoverGravar: false,
      hoverFinalizar: false,
      hoverDesarquivar: false,
      hoverDesaprovar: false,
      hoverDesocupar: false,
      hoverCancelarFinalizacao: false,
      hoverRemover: false,
      hoverAprovar: false,
      hoverCancelarDesocupacao: false,

      historicoASerDesfeito: { clienteAnterior: {} }
    };
  },
  created() {
    if(this.aluguelNovo) {
      this.configurarCampoCorretor();
      this.configurarParametros(this.usuarioLogado.imobiliaria.parametros);
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado; },
      isSuporte(state){return state.usuarioLogado.suporte;},
      isGestaoContratoColigado(state){ return state.usuarioLogado.imobiliaria.parametros.gestaoContratosColigados },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CONTRATOS_ALUGUEL" })[0] }
    }),
    ...mapState("alugueisContratosStore", {
      alugueis(state) { return state.listaAlugueis; },
      aluguelPesquisa(state) { return state.aluguelPesquisa; },
      
      aluguel(state) { return state.aluguelSelecionado; },
      formularios(state) { return state.formularios; },
      logs(state) { return state.logs; },
      contasBancariasRepasse(state) {
        return state.aluguelSelecionado.contasBancariasRepasse;
      },
      arquivos(state){ return state.aluguelSelecionado.diretorios},
      //fiadorSelecionado(state) { return state.fiadorSelecionado; },
      labelQuantidade(state) {return state.labelQuantidade},

      dadosPesquisaAluguel() {
        return (
          this.aluguelPesquisa.status != "" ||
          this.aluguelPesquisa.dataInicio != "" ||
          this.aluguelPesquisa.dataFim != "" ||
          this.aluguelPesquisa.imovel.idNaImobiliaria != "" ||
          this.aluguelPesquisa.imovel.endereco != "" ||
          this.aluguelPesquisa.locatario.nome != "" ||
          this.aluguelPesquisa.proprietario.nome != ""
        )
      },
      boletosAvulsos(state) { return state.boletosAvulsos }
    }),

    observacoesFiltradas() {
      return this.aluguel.observacoesDosUsuarios
        .filter(this.filtrarObservacoes);
    },

    isVisibleTabVistorias() {
      return !this.aluguelNovo
        && this.usuarioLogado.imobiliaria.appVistoria;
    },

    //PESQUISA
    status() { return STATUS_CONTRATO_ALUGUEL; },
    statusRecibo() { return STATUS_RECIBO_REPASSE; },
    tipoItemRecibo() { return TIPO_ITEM_RECIBO; },
    tipoVistoria() { return TIPO_VISTORIA; },
    statusVistoria() { return STATUS_VISTORIA; },
    estadoVistoria() { return ESTADO_VISTORIA; },
    formaAluguel() { return FORMA_ALUGUEL; },
    periodicidadeAluguel() { return PERIDIOCIDADE_ALUGUEL },
    tipoLocacao() { return TIPO_LOCACAO; },
    tipoAluguel() { return TIPO_ALUGUEL; },
    indiceReajuste() { return INDICE_REAJUSTE; },
    formaPagamentoSeguroIncendio() { return FORMA_PAGAMENTO_SEGURO_INCENDIO; },
    tipoGarantia() { return TIPO_GARANTIA; },
    regraRepasse() { return REGRA_REPASSE; },
    tipoGarantiaPesquisa() { return TIPO_GARANTIA_PESQUISA; },

    tipoBoleto() {
      return [
        ...TIPO_BOLETO,
        { label: 'Todos', data: undefined },
      ];
    },

    bancos() {
      return BANCOS;
    },

    textoBotaoToggleMaisFiltros() {
      return this.isVisibleFiltrosAdicionais
        ? 'Menos Filtros'
        : 'Mais Filtros';
    },

    loading() {
      return this.$store.state.loading;
    },

    isPendente() { return this.aluguel.status === 'PENDENTE' },
    isAprovado() { return this.aluguel.status === 'APROVADO' },
    isEmDesocupacao() { return this.aluguel.status === 'EM_DESOCUPACAO' },
    isFinalizado() { return this.aluguel.status === 'FINALIZADO' },

    //CADASTRO
    perfisDisponiveis() {
      let tree = []
      let perfil = {}
      
      perfil.label = "Proprietário"
      perfil.children = []
      this.aluguel.imovel.proprietariosBeneficiarios.forEach(item => {
        if(item.perfis[0].perfil === 'PROPRIETARIO') {
          perfil.children.push({ label: item.nome, id: item.id })        
        }
      });
      tree.push(perfil)

      perfil = new Object
      perfil.label = "Beneficiário"
      perfil.children = []
      this.aluguel.imovel.proprietariosBeneficiarios.forEach(item => {
        if(item.perfis[0].perfil === 'BENEFICIARIO') {
          perfil.children.push({ label: item.nome, id: item.id })        
        }
      });
      if(perfil.children.length > 0){
        tree.push(perfil)
      }

      perfil = new Object
      perfil.label = "Locatário"
      perfil.children = []
      perfil.children.push({ label: this.aluguel.locatario.nome, id: this.aluguel.locatario.id })        
      tree.push(perfil)

      perfil = new Object
      perfil.label = "Fiador"
      perfil.children = []
      this.aluguel.fiadores.forEach(item => {
        perfil.children.push({ label: item.nome, id: item.id })        
      });
      if(perfil.children.length > 0){
        tree.push(perfil)
      }

      return tree;
    },
    urlImagens() {
      if(this.comodoSelecionado.imagens) {
        return this.comodoSelecionado.imagens.map(imagem => imagem.url);
      } 
      return [];
    },
    usuariosDisponiveis() {
      return this.$store.state.alugueisContratosStore.usuariosDisponiveis;
    },
    clientesDisponiveis() {
      return this.$store.state.alugueisContratosStore.clientesDisponiveis;
    },
    imoveisDisponiveis() {
      return this.$store.state.alugueisContratosStore.imoveisDisponiveis;
    },
    aluguelNovo() {
      return this.aluguel.id == 0;
    },
    disableAlteracao() {
      return this.aluguel.id != 0 && this.aluguel.status != "PENDENTE";
    },
    vistoriasFiltradas() {
      if(this.exibirVistoriasCanceladas){
        return this.aluguel.vistorias.filter(item => {return item.status === 'CANCELADO'})
      } else {
        return this.aluguel.vistorias.filter(item => {return item.status !== 'CANCELADO'})
      }
    },
    
    valorComissao(){
      return (this.aluguel.comissao/100) * this.aluguel.valor
    },

    util() {
      return Util;
    },
    exibirBotaoAlterarReajusteRenovacao(){
      return this.isSuporte && this.usuarioLogado.imobiliaria.parametros.alterarPeriodoRecibos && !this.aluguel.isReajusteAlterado && (this.aluguel.status === "APROVADO" || this.aluguel.status === "EM_DESOCUPACAO");
    },
    exibirBotaoDesfazerAlteracaoReajusteRenovacao(){
      return this.isSuporte && this.usuarioLogado.imobiliaria.parametros.alterarPeriodoRecibos && this.aluguel.isReajusteAlterado;
    },
    exibirBotaoNovo() {
      return ( this.permissoes.cadastro );
    },
    exibirBotaoNovoCliente() {
      return (
        this.aluguel.id == 0
      );
    },
    exibirBotaoUploadArquivo() {
      return this.tabSelecionada == "arquivos";
    },
    exibirBotaoGravar() {
      return (
        (this.permissoes.cadastro &&
          this.aluguel.id === 0) ||
        (this.permissoes.alteracao &&
          this.aluguel.id !== 0 &&
          (this.aluguel.status === "PENDENTE" || this.aluguel.status === "APROVADO" || this.aluguel.status === "FINALIZADO"))
      );
    },
    exibirAlterarAprovado(){
      return this.aluguel.status === "APROVADO" && this.permissoes.alterarAluguelAprovado;
    },
    exibirAlterarTitularidade() {
      return this.aluguel.status === "APROVADO"
    },
    expandirGravar(){
      return this.aluguel.id === 0 || this.hoverGravar;
    },
    exibirBotaoGerarFichaCadastral() {
      return this.tabSelecionada === 'resumo' && !(this.aluguel.status === 'ARQUIVADO');
    },
    exibirLabelReajusteRenovacao(){
      return this.aluguel.previsaoFim && this.aluguel.dataReajuste;
    },
    exibirBotaoDesocupar(){
      return this.aluguel.status === "APROVADO";
    },
    exibirBotaoFinalizar(){
      return this.permissoes.alteracao && (this.aluguel.status === "APROVADO" || this.aluguel.status === "EM_DESOCUPACAO");
    },
    exibirBotaoDesarquivar(){
      return this.permissoes.alteracao && this.aluguel.status === "ARQUIVADO";
    },
    exibirBotaoCancelarFinalizacao(){
      return this.permissoes.alteracao && this.aluguel.status === "FINALIZADO";
    },
    exibirBotaoCancelarDesocupacao(){
      return this.aluguel.status === "EM_DESOCUPACAO";
    },
    exibirBotaoCriarDiretorio() {
      return (
        this.permissoes.geracaoFormularios 
      );
    },
    exibirBotaoGerarFormulario() {
      return (
        this.permissoes.geracaoFormularios &&
        this.tabSelecionada == "formularios" &&
        this.formularioSelecionado.nomeArquivo
      );
    },
    exibirBotaoRemover() {
      return (
        this.permissoes.remocao &&
        (this.aluguel.status === "PENDENTE" || this.aluguel.status === 'FINALIZADO') &&
        this.aluguel.id !== 0
      );
    },
    exibirBotaoAprovar() {
      return (
        this.permissoes.alteracao &&
        this.aluguel.status === "PENDENTE" &&
        this.aluguel.id !== 0
      );
    },
    exibirBotaoDesaprovar() {
      return (
        this.permissoes.alteracao &&
        this.aluguel.status === "APROVADO" &&
        this.aluguel.id !== 0
      );
    },
    exibirBotaoGerarFormularioVistoria() {
      return this.tabSelecionada === 'resumo' && !this.aluguel.status === 'ARQUIVADO';
    },
    exibirBotaoAgendarVistoria() {
      return this.aluguel.id != 0 && this.tabSelecionada === "vistorias"
    },
    exibirBotaoGerarRelatorioObservacao() {
      return this.aluguel.id != 0 && this.tabSelecionada == "observacoes";
    },
    exibirBotaoAlterarVencimentoAluguel() {
      return (this.isAprovado || this.isEmDesocupacao || this.isFinalizado)
        && this.permissoes.alterarVencimentoAluguel;
    },
    exibirBotaoResumoContrato() {
      return this.isPendente || this.isAprovado || this.isEmDesocupacao || this.isFinalizado;
    },
    exibirBotaoResumoFinanceiro(){
      return this.isAprovado || this.isEmDesocupacao || this.isFinalizado;
    },
    exibirBotaoGerarDimob(){
      return this.isAprovado || this.isEmDesocupacao || this.isFinalizado;
    },
    exibirBotaoReajustarAluguel(){
      return this.isAprovado && this.permissoes.reajustarAluguel;
    },
    exibirBotaoCancelarReajusteAluguel() {
      return this.isAprovado && this.permissoes.cancelarReajuste;
    },
    exibirBotaoRenovarAluguel() {
      return this.isAprovado && this.permissoes.renovarAluguel;
    },
    exibirBotaoCancelarRenovacaoAluguel() {
      return this.isAprovado && this.permissoes.cancelarRenovacao;
    },
    exibirBotaoProrrogarAluguel() {
      return (this.isAprovado || this.isEmDesocupacao)
        && this.permissoes.prorrogarAluguel;
    },
    exibirBotaoCancelarProrrogacaoAluguel() {
      return (this.isAprovado || this.isEmDesocupacao)
        && this.permissoes.cancelarProrrogacao;
    },
    exibirBotaoAlterarCarenciaAluguel() {
      return (this.isAprovado || this.isEmDesocupacao)
        && this.permissoes.alterarCarenciaAluguel;
    },
    exibirBotaoAlterarTaxaAdmAluguel() {
      return (this.isAprovado || this.isEmDesocupacao || this.isFinalizado)
        && this.permissoes.alterarTaxaDeAdmAluguel;
    },
    exibirBotaoAlterarValorAluguel() {
      return (this.isAprovado || this.isEmDesocupacao || this.isFinalizado)
        && this.permissoes.alterarValorAluguel;
    },
    exibirBotaoAlterarRenovacaoAluguel() {
      return this.isAprovado && this.permissoes.cancelarRenovacao;
    },
    exibirColunaRemoverObservacao() {
      return this.permissoes.removerObservacoes;
    },
    disableCampoAtendente() {
      return !this.permissoes.alteracaoCorretor;
    },
    exibirBotaoGerarBoleto() {
      return this.tabSelecionada == "boletos" && this.boletoAvulsoSelecionado && this.boletoAvulsoSelecionado.status === "EM_ABERTO";
    },
    exibirBotaoGerarBoletos() {
      return this.tabSelecionada == "boletos"
    },
    exibirBotaoProrrogarBoletoAvulso() {
      const currentTabIsBoletos = this.tabSelecionada == "boletos";
      const boletoEstaEmAberto = this.boletoAvulsoSelecionado && this.boletoAvulsoSelecionado.status === "EM_ABERTO";
      const boletoAindaNaoFoiProrrogado = this.boletoAvulsoSelecionado && !this.boletoAvulsoSelecionado.dataProrrogacao;

      return currentTabIsBoletos && boletoEstaEmAberto && boletoAindaNaoFoiProrrogado;
    },
    exibirBotaoCancelarProrrogacaoBoletoAvulso() {
      const currentTabIsBoletos = this.tabSelecionada == "boletos";
      const boletoEstaEmAberto = this.boletoAvulsoSelecionado && this.boletoAvulsoSelecionado.status === "EM_ABERTO";
      const boletoJaFoiProrrogado = this.boletoAvulsoSelecionado && this.boletoAvulsoSelecionado.dataProrrogacao;

      return currentTabIsBoletos && boletoEstaEmAberto && boletoJaFoiProrrogado;
    },
    exibirBotaoAdicionarBoleto() {
      return this.tabSelecionada == "boletos";
    },
    exibirBotaoAdicionarLancamento() {
      return this.tabSelecionada == "lancamentos";
    },
    exibirBotaoAdicionarDesconto() {
      return this.tabSelecionada == "descontos";
    },
    
    habAlterarIdContrato() {
      return this.permissoes.alterarId == false && !this.aluguelNovo;
    },

    boletosAvulsosFiltratos() {
      return this.organizarBoletosPorData(this.aluguel.boletosAvulsos)
      .filter(this.filtroNomeClienteBoleto)
      .filter(item => { return this.pesquisaBoletosAvulsos.tipoBoleto ? (item.tipoBoleto === this.pesquisaBoletosAvulsos.tipoBoleto) : true })
    },

    bloqueioInformacoes() {
      return ((this.aluguel.status === 'APROVADO' ||
      this.aluguel.status === 'EM_DESOCUPACAO' ||
      this.aluguel.status === 'FINALIZADO') && !(this.configurarAprovado && this.permissoes.alterarAluguelAprovado))
    },

    exibirTipoGarantia() {
      return this.aluguel.tipoAluguel === 'GARANTIDO'
    },

    exibirTipoGarantiaPesquisa() {
      return this.aluguelPesquisa.tipoAluguel === 'GARANTIDO' || this.aluguelPesquisa.tipoAluguel == undefined;
    },
     //ARQUIVOS
     linhasArquivo(){
      if(this.arquivoSelecionado){
        return Object.entries(this.arquivoSelecionado)
        .filter(([key]) => this.keysArquivo.includes(key) )
        .map(([key,value]) => ({key, value})).sort((a, b ) => {
          if(a.key === "localizacaoFisica"){
            return 1
          }
          if(b.key === "localizacaoFisica"){
            return -1
          }
        })
      }      
    },

    proprietariosImovel() {
      if(this.aluguel.imovel.id > 0) {
        return this.aluguel.imovel.proprietariosBeneficiarios.filter((proprietarioBeneficiario) => proprietarioBeneficiario.perfil === 'Proprietário').map((proprietarioBeneficiario) => { return { ...proprietarioBeneficiario, isSelecionadoParaTroca: false } });
      } else {
        return []
      }
    },
    
    categoriaCliente() {
      return CATEGORIA_CLIENTE;
    }
  },
  watch: {
    aluguelNovo(newValue) {
      if (newValue) {
        this.tabSelecionada = "detalhes";
        this.tabKey++;
      }
    },
    "aluguel.id": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.tabSelecionada = "detalhes";
        this.observacaoSelecionada = {};
        this.boletoAvulsoSelecionado = undefined;
        this.configurarAprovado = false;
      }
    },
    "aluguel.valor": function(newValue) {
      this.aluguel.multaRescisao = this.aluguel.mesesMultaRescisao * newValue;
    },
    "aluguel.mesesMultaRescisao": function(newValue) {
      this.aluguel.multaRescisao = newValue * this.aluguel.valor
    },
    "aluguel.dataInicio": function(newValue) {
      const isAluguelCadastrado = this.aluguel.id !== 0;
      if(isAluguelCadastrado) return;

      if(!this.util.validarData(newValue) || newValue.length < 10) { return }
      
      // Data do Primeiro Vencimento
      switch(this.aluguel.formaAluguel) {
				case "VENCIDO_30_DIAS":
					var data = this.util.stringParaData(this.aluguel.dataInicio)
					
					if(data.getMonth() == 0 && data.getDate() > 28) {
						data.setDate(28);
						data.setMonth(1);
					} else {
						data.setMonth(data.getMonth() + 1);
					}
					
          this.aluguel.dataPrimeiroVencimento = this.util.dataParaString(data)

					break;
				case "ADIANTADO":
          this.aluguel.dataPrimeiroVencimento = this.aluguel.dataInicio  
          break;
        default:
            break;
      }
      
      // Data de Rescisão
      let dataRescisao = ''

      if(this.aluguel.duracao > 0){
        dataRescisao = this.util.adicionarDias(newValue, -1)
        dataRescisao = this.util.adicionarMeses(dataRescisao, this.aluguel.duracao)
        dataRescisao = this.util.dataParaString(dataRescisao)

        this.aluguel.dataRescisao = dataRescisao
      }
    },
    "aluguel.duracao":function(newV, oldV) {
      const isAluguelCadastrado = this.aluguel.id !== 0;
      if(isAluguelCadastrado) return;
      if(!this.util.validarData(this.aluguel.dataInicio) || this.aluguel.dataInicio.length < 10) { return }

      let dataRescisao = ''

      if(newV !== oldV && newV > 0){
        dataRescisao = this.util.adicionarDias(this.aluguel.dataInicio, -1)
        dataRescisao = this.util.adicionarMeses(dataRescisao, newV)
        dataRescisao = this.util.dataParaString(dataRescisao)

        this.aluguel.dataRescisao = dataRescisao
      }
    }, 
    "aluguel.imovel": function(newV, oldV) {
      if(newV.id !== oldV.id && newV.id !== 0 && this.aluguel.id === 0){
        this.recuperarImovel(newV)
        .then(resultado => {
          if(resultado.status == "SUCESSO") {
            if(this.aluguel.contasBancariasRepasse) {
              this.aluguel.contasBancariasRepasse = []
            }
            this.aluguel.imovel = resultado.item
            this.atualizarValores()
          }
        })
        .catch(() => {
          this.$message.error("Oops, this is a error message.");
        });
      }
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),

    ...mapActions("vendasRelatoriosStore", ["gerarRelatorio", "listarUsuarios"]),
    ...mapActions("loginStore", ["validarAcesso"]),
    ...mapActions("alugueisClientesStore", ["recuperarClienteAluguel"]),
    ...mapActions("alugueisImoveisStore", ["recuperarImovel"]),
    ...mapActions("alugueisContratosStore", [
      "limparAluguelPesquisa",
      "limparAlugueisListados",
      "atualizarContasRepasse",
      "verificarAprovacaoAluguel",
      "aprovarAluguel",
      "desaprovarAluguel",
      "cancelarDesocupacaoAluguel",
      "cancelarFinalizacao",
      "gerarFormularioAluguel",
      "gerarResumo",
      "gravarAluguel",
      "desfazerAlteracaoDataReajuste",
      "enviarRelatorio",
      "listarClientes",
      "listarImoveis",
      "listarUsuarios",
      "listarAlugueis",
      "novoAluguel",
      "configurarParametros",
      "recuperarFormularios",
      "recuperarLogs",
      "recuperarObservacaoAluguel",
      "recuperarPerguntasFormulario",
      "recuperarAluguel",
      "removerArquivo",
      "removerDiretorioAluguel",
      "removerObservacao",
      "removerPagamentoComissao",
      "removerAluguel",
      "desarquivarAluguel",
      "cancelarVistoriaAluguel",
      "removerVistoriaAluguel",
      "forcarConclusaoVistoriaAluguel",
      "removerDesconto",
      "removerLancamentoFuturo",
      "removerBoletoAvulso",
      "cancelarProrrogacaoBoletoAvulso",
      "cancelarReajusteAluguel",
      "cancelarRenovacaoAluguel",
      "cancelarProrrogacaoAluguel",
      "gerarFormularioVistoria",
      "gerarLaudoVistoria",
      "enviarLaudoVistoria",
      "removerCobrancasDoRecibo",
      "removerRegistrosDoContrato",
      "removerDiretorioArquivos",
      "retomarVistoria",
      "desfazerTrocaTitularidadeProprietario",
      "desfazerTrocaTitularidadeLocatario"
    ]),
    //PESQUISA
    filtroNomeClienteBoleto(boleto) {
      return this.pesquisaBoletosAvulsos.nomeCliente ?
      (boleto.cliente.nome.toLowerCase().includes(this.pesquisaBoletosAvulsos.nomeCliente.trim().toLowerCase())) : true;
    },

    filtroTipoBoleto(boleto) {
      return boleto.tipo == this.pesquisarBoletosAvulsos.tipoBoleto
    },

    filtrarObservacoes(observacao) {
      const descricao = observacao.descricao !== null ? Util.removerAcentos(observacao.descricao.trim().toLowerCase()) : '';
      const assunto = observacao.assunto !== null ? Util.removerAcentos(observacao.assunto.trim().toLowerCase()) : '';
      
      const searchTerm = Util.removerAcentos(this.filtroObservacoes.trim().toLowerCase());

      return descricao.includes(searchTerm) || assunto.includes(searchTerm);
    },

    novo() {
      this.novoAluguel();
      this.configurarCampoCorretor();
      this.configurarParametros(this.usuarioLogado.imobiliaria.parametros);
      this.irParaSecaoNovo();
    },
    validarDuracao(rule, value, callback){
      if((Number(value) < Number(this.aluguel.reajuste)) && (this.aluguel.id === 0 || this.permissoes.alterarAluguelAprovado)){
        return callback(new Error("Data dever maior ou igual a reajuste"));
      }
      return callback()
    },
    pesquisarHandler() {
      this.aluguelPesquisa.pagina = 0;
      this.limparAlugueisListados();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if(this.permissoes.visualizacaoSomenteContratosCorretor) {
        this.aluguelPesquisa.usuario = { id: this.usuarioLogado.id };
      }
      if(this.aluguelPesquisa.pagina == 0) { this.showLoading(); }

      this.listarAlugueis(this.aluguelPesquisa)
      .then((resultado) => {
        if(this.aluguelPesquisa.pagina == 0) { this.hideLoading(); }
        
        if(resultado.lista.length == 100) {
          this.aluguelPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.aluguelPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).finally(() => {
        this.hideLoading();
      });
    },
    handleNodeClick(node){
      this.recuperarCliente(node)
    },
    limparPesquisa() {
      this.limparAluguelPesquisa();
    },
    recuperar(aluguelSelecionado) {
      this.irParaSecaoAluguel();
      let payload = { id: aluguelSelecionado.id };
      this.configurarAprovado = false;
      
      this.showLoading();
      this.vistoriaSelecionada = {};
      this.comodoSelecionado = {
        imagens: []
      };
      this.recuperarAluguel(payload)
      .then(() => {
        this.hideLoading();
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },

    handleClickToggleMaisFiltros() {
      this.isVisibleFiltrosAdicionais = !this.isVisibleFiltrosAdicionais;
    },

    //CADASTRO
    permitirAlterarAprovado(){
      this.configurarAprovado = !this.configurarAprovado;
      if(this.configurarAprovado){
        this.$alert("Campos disponíveis para editar: Duração, Reajuste, Data de Início, Data do 1° Vencimento e Rescisão Contratual",
         { confirmButtonText: 'Continuar', type: 'info' });
      }
    },

    changeFormaAluguel() {
      const isAluguelCadastrado = this.aluguel.id !== 0;
      if(isAluguelCadastrado) return;
      
      this.limparDataInicio();
      this.limparDataPrimeiroVencimento();
    },

    limparDataInicio() {
      this.aluguel.dataInicio = undefined;
    },
    limparDataPrimeiroVencimento() {
      this.aluguel.dataPrimeiroVencimento = undefined;
    },

    verificarAprovacaoHandler() {
      this.$refs["formAluguel"].validate(valid => {
        if(valid) {
          this.verificarAprovacao();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },

    verificarAprovacao() {
      this.showLoading();
      let payload = { ...this.aluguel, status: 'APROVADO', imovelVenda: { id: this.aluguel.imovel.idImovelAssociado }};
      delete payload.diaUtil
      this.verificarAprovacaoAluguel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            if(resultado.mensagem.includes('Deseja continuar mesmo assim?')){
              this.$confirm(resultado.mensagem, "Atenção", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                type: "warning"
              }).then(() => {
                this.aprovarHandler()
              });
            } else {
              this.$message.warning(resultado.mensagem);
              this.pesquisarHandler();
            }
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    aprovarHandler() {
      this.showLoading();
      let payload = { ...this.aluguel, status: 'APROVADO', imovelVenda: { id: this.aluguel.imovel.idImovelAssociado }};
      if(payload.formaAluguel === 'DIA_UTIL_MES') {
        const dataVencimento = new Date(Util.stringParaData(payload.dataInicio));

        dataVencimento.setDate(1);

        payload.dataPrimeiroVencimento = Util.dataParaString(dataVencimento);
      }
      if(payload.regraRepasse === 'DIA_FIXO' && payload.carenciaRepasse <= 0) {
        this.exibirAlert("Atenção", "A carência do repasse não pode ser 0 ou menor.");
        return;
      } 
      this.aprovarAluguel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    desaprovarHandler() {
      this.$confirm("Todos os recibos e itens de recibo serão excluídos. Tem certeza que deseja desaprovar este contrato?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        if(this.aluguel.imovel.disponibilizadoVenda && this.aluguel.imovel.statusImovelAssociado === 'INDISPONIVEL'){
          this.$confirm("O imóvel deste contrato está indisponível para venda. Deseja disponibilizá-lo?", "Atenção", {
            distinguishCancelAndClose: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            type: "warning"
          }).then(() => {
            this.desaprovar(false)
          }).catch(action => {
            if(action === 'cancel'){
              this.desaprovar(true)
            }  
          });
        } else {
          this.desaprovar(false)
        }
      });
    },
    desaprovar(indisponibilizarImovel){
      this.showLoading();
      let payload = { id: this.aluguel.id, imovelVenda: { id: this.aluguel.imovel.idImovelAssociado }, indisponibilizarImovelVenda: indisponibilizarImovel, versao: this.aluguel.versao, locatario: this.aluguel.locatario };
      this.desaprovarAluguel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    cancelarDesocupacaoHandler(){
      this.$confirm("Tem certeza que deseja cancelar a desocupação deste contrato?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.showLoading();
        let payload = { id: this.aluguel.id };
        this.cancelarDesocupacaoAluguel(payload)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.pesquisarHandler();
              break;
            default:
              this.$message.warning(resultado.mensagem);
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
      });
    },
    cancelarFinalizacaoHandler(){
      this.$confirm("Tem certeza que deseja cancelar a finalização deste contrato?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.showLoading();
        let payload = { id: this.aluguel.id };
        this.cancelarFinalizacao(payload)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.pesquisarHandler();
              break;
            default:
              this.$message.warning(resultado.mensagem);
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
      });
    },
  desfazerAlteracaoReajuste(){
    this.showLoading();
    this.desfazerAlteracaoDataReajuste({
      id: this.aluguel.id,
    })
      .then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
  },
    gravarHandler() {
      this.$refs["formAluguel"].validate(valid => {
        if(valid) {
          this.gravar();
        } else {
          if(Number(this.aluguel.duracao) < Number(this.aluguel.reajuste) && (this.aluguel.id === 0 || this.permissoes.alterarAluguelAprovado)){
            this.exibirAlert("Atenção", "Duração não deve ser menor que Reajuse.");  
          }else{
            this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
          }
        }
      });
    },
    gravar() {
      let payload = this.aluguel;
      if(this.aluguel.id === 0){
        this.aluguel.status = 'PENDENTE';
      }

      if(payload.formaAluguel === 'DIA_UTIL_MES') {
        const dataVencimento = new Date(Util.stringParaData(payload.dataInicio));

        dataVencimento.setDate(1);

        payload.dataPrimeiroVencimento = Util.dataParaString(dataVencimento);

        payload.regraRepasse = 'DIAS_CORRIDOS';
        payload.carenciaRepasse = 0;
      }

      if(payload.regraRepasse === 'DIA_FIXO' && payload.carenciaRepasse <= 0) {
        this.exibirAlert("Atenção", "A carência do repasse não pode ser 0 ou menor.");
        return;
      } 

      if((Number(payload.reajuste) > Number(payload.duracao)) && this.permissoes.alterarAluguelAprovado){
        this.exibirAlert("Atenção", "A duração do aluguel deve ser maior ou igual ao reajuste.");
        return;
      }
      
      this.showLoading();
      this.gravarAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.configurarAprovado = false;
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
    },

    confirmarRemocaoAluguel() {
      this.$confirm('Tem certeza que deseja remover este Aluguel?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      })
      .then(this.removerHandler)
      .catch(() => {});
    },
    alertarRemocaoAluguel(){
      if(this.isPendente){
        this.confirmarRemocaoAluguel();
      }else{
        this
        .$confirm("O contrato será arquivado e não será mais possível incluí-lo em relatórios ou realizar qualquer ação nele. Recomendamos que salve todas as informações necessárias antes de prosseguir.", 
        'Atenção', {
          confirmButtonText: 'Ok, estou ciente dos riscos',
          cancelButtonText: 'Cancelar'
        })
        .then(this.confirmarRemocaoAluguel)
        .catch(() => {});
      } 
    },

    removerHandler() {
      const payload = { 
        id: this.aluguel.id,
        status: this.aluguel.status
       };
      
      this.showLoading();

      this.removerAluguel(payload).then(resultado => {
        switch(resultado.status) {
          case 'SUCESSO':
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            this.configurarParametros(this.usuarioLogado.imobiliaria.parametros);
            break;

          case 'FALHA':
            this.exibirAlert('Atenção', resultado.mensagem, 'error');
            break;
          
          case 'ERRO':
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
      }).finally(() => {
        this.hideLoading();
      });
    },
    confirmarDesarquivarAluguel() {
      this.$confirm('Tem certeza que deseja desarquivar este Aluguel?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      })
      .then(this.desarquivarHandler)
      .catch(() => {});
    },
    desarquivarHandler() {
      const payload = { 
        id: this.aluguel.id,
        status: this.aluguel.status
       };
      
      this.showLoading();
      this.desarquivarAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.pesquisarHandler();
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
    },
    adicionarFiador() {
      if(this.fiadorSelecionado == undefined || this.fiadorSelecionado.id == undefined || this.fiadorSelecionado.id == 0) { return; }

      if(this.aluguel.fiadores.filter((elemento) => { return elemento.id == this.fiadorSelecionado.id }).length == 0) {
        this.aluguel.fiadores.push(this.fiadorSelecionado);
      }

      this.fiadoresDisponiveis = [];
      this.fiadorSelecionado = {};
    },
    removerFiador(fiador) {
      this.$confirm("Tem certeza que deseja remover este Fiador?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.aluguel.fiadores = this.aluguel.fiadores.filter((elemento) => { return elemento.id != fiador.id });
      });
    },
    // calcularPercentualDescontoPontualidade() {
    //   if(this.aluguel.valor === 0) {
    //     this.aluguel.desconto = 0
    //     this.aluguel.valorDesconto = 0
    //     return;
    //   }
      
    //   this.aluguel.desconto = new BigDecimal(this.aluguel.valorDesconto)
    //   .multiply(new BigDecimal(100))
    //   .divide(new BigDecimal(this.aluguel.valor)
    //   .round(10, BigDecimal.RoundingModes.HALF_UP))
    //   .round(2, BigDecimal.RoundingModes.HALF_UP)
    //   .getValue()
    // },
    
    calcularPercentualDescontoPontualidade() {
      if(this.aluguel.valor > 0) {
        this.aluguel.desconto = this.aluguel.valorDesconto*100 / this.aluguel.valor;
      }
    },

    cancelarReajusteHandler(){
      this.$confirm("Tem certeza que deseja cancelar o Reajuste deste aluguel?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.cancelarReajuste();
       });
    },

    cancelarReajuste(){      
        this.showLoading()
        this.cancelarReajusteAluguel({id: this.aluguel.id})
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
                this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
              if(resultado.mensagem.includes('cobranças')) {
                this.$confirm(`${resultado.mensagem}. Deseja deletar as cobranças e continuar o cancelamento da renovação?`, "Atenção", {
                  confirmButtonText: "Sim",
                  cancelButtonText: "Não",
                  type: "warning"
                }).then(() => {
                  this.showLoading();
                  this.removerCobrancasDoRecibo({id: this.aluguel.id})
                  .then(result => {
                    switch (result.status) {
                      case "SUCESSO":
                        this.cancelarReajuste();
                        break;
                      case "ERRO":
                        this.$message.error(result.mensagem)
                        break;
                    }
                  })
                }).catch(() => {
                  this.$message.error(resultado.mensagem)
                });
                break;
              }
              if(resultado.mensagem.includes('registros')) {
                this.$confirm(`${resultado.mensagem}. Deseja cancelar os registros e continuar o cancelamento do reajuste?`, "Atenção", {
                  confirmButtonText: "Sim",
                  cancelButtonText: "Não",
                  type: "warning"
                }).then(() => {
                  this.showLoading();
                  this.removerRegistrosDoContrato({
                    id: this.aluguel.id,
                    locatario: {
                      id: this.aluguel.locatario.id
                    },
                    ultimoMesSerieReajusteAnterior: 1,
                  }).then(result => {
                    switch (result.status) {
                      case "SUCESSO":
                        this.cancelarReajuste();
                        break;
                      case "ERRO":
                        this.$message.error(result.mensagem)
                        break;
                    }
                  })
                }).catch(() => {
                  this.$message.error(resultado.mensagem)
                });
                break;
              }
              this.hideLoading();
              this.$message({
                message: resultado.mensagem,
                type: 'warning',
                duration: 10000});
              break;
            default:
              this.hideLoading();
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro.");
        });
    },

    cancelarRenovacaoHandler(){
      this.$confirm("Tem certeza que deseja cancelar a Renovação deste aluguel?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.cancelarRenovacao();
      });
    },


    cancelarRenovacao(){
     
      this.showLoading()
      this.cancelarRenovacaoAluguel({id: this.aluguel.id})
      .then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
              this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            if(resultado.mensagem.includes('cobranças')) {
              this.$confirm(`${resultado.mensagem}. Deseja deletar as cobranças e continuar o cancelamento da renovação?`, "Atenção", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                type: "warning"
              }).then(() => {
                this.showLoading();
                this.removerCobrancasDoRecibo({id: this.aluguel.id})
                .then(result => {
                  switch (result.status) {
                    case "SUCESSO":
                      this.cancelarRenovacaoAluguel({id: this.aluguel.id})
                      .then((response) => {
                        this.hideLoading();
                        if(response.status === 'SUCESSO') { this.$message.success(response.mensagem) }})
                      .catch((response) => { if(response.status === 'SUCESSO') { this.$message.error(response.mensagem) } })
                      break;
                    case "ERRO":
                      this.$message.error(result.mensagem)
                      break;
                  }
                })
              }).catch(() => {
                this.$message.error(resultado.mensagem)
              });
              break;
            }
            if(resultado.mensagem.includes('registros')) {
              this.$confirm(`${resultado.mensagem}. Deseja remover os registros de recibos e continuar o cancelamento da renovação?`, "Atenção", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                type: "warning"
              }).then(() => {
                this.showLoading();
                this.removerRegistrosDoContrato({
                  id: this.aluguel.id,
                  locatario: {
                    id: this.aluguel.locatario.id
                  },
                  ultimoMesSerieRenovacaoAnterior: 1,
                }).then(result => {
                  switch (result.status) {
                    case "SUCESSO":
                      this.cancelarRenovacao();
                      break;
                    case "ERRO":
                      this.$message.error(result.mensagem)
                      break;
                  }
                })
              }).catch(() => {
                this.$message.error(resultado.mensagem)
              });
              break;
            }
            this.hideLoading()
            this.$message({message: resultado.mensagem,
            type: 'warning',
            duration: 10000});
            break;
          default:
            this.hideLoading()
            this.$message.error(resultado.mensagem);
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
      
    },

    cancelarProrrogacaoHandler(){
      this.$confirm("Tem certeza que deseja cancelar a Prorrogação deste aluguel?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.cancelarProrrogacao();
      });
    },

    cancelarProrrogacao(){
      this.showLoading();
      this.cancelarProrrogacaoAluguel({id: this.aluguel.id})
      .then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
              this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            if(resultado.mensagem.includes('cobranças')) {
              this.$confirm(`${resultado.mensagem}. Deseja deletar as cobranças e continuar o cancelamento da prorrogação?`, "Atenção", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                type: "warning"
              }).then(() => {
                this.showLoading();
                this.removerCobrancasDoRecibo({id: this.aluguel.id})
                .then(result => {
                  switch (result.status) {
                    case "SUCESSO":
                      this.cancelarProrrogacaoAluguel({id: this.aluguel.id})
                      .then((response) => {
                        this.hideLoading();
                        if(response.status === 'SUCESSO') { this.$message.success(response.mensagem) }})
                      .catch((response) => { if(response.status === 'SUCESSO') { this.$message.error(response.mensagem) } })
                      break;
                    case "ERRO":
                      this.$message.error(result.mensagem)
                      break;
                  }
                })
              }).catch(() => {
                this.$message.error(resultado.mensagem)
              });
              break;
            }
            if(resultado.mensagem.includes('registros')) {
              this.$confirm(`${resultado.mensagem}. Deseja remover os registros de recibos e continuar o cancelamento da prorrogação?`, "Atenção", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                type: "warning"
              }).then(() => {
                this.showLoading();
                this.removerRegistrosDoContrato({
                  id: this.aluguel.id,
                  locatario: {
                    id: this.aluguel.locatario.id
                  },
                  ultimoMesSerieProrrogacaoAnterior: 1,
                }).then(result => {
                  switch (result.status) {
                    case "SUCESSO":
                      this.cancelarProrrogacao();
                      break;
                    case "ERRO":
                      this.$message.error(result.mensagem)
                      break;
                  }
                })
              }).catch(() => {
                this.$message.error(resultado.mensagem)
              });
              break;
            }
            this.hideLoading();
            this.$message({message: resultado.mensagem,
              type: 'warning',
              duration: 10000});
            break;
          default:
            this.hideLoading();
            this.$message.error(resultado.mensagem);
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
    },

    gerarFichaCadastralHandler() {
      let nomeRelatorio;
      if(this.aluguel.locatario.personalidadeJuridica === 'PESSOA_FISICA') {
        nomeRelatorio = 'FICHA_CADASTRAL_LOCACAO';
      } else {
        nomeRelatorio = 'FICHA_CADASTRAL_LOCACAO_JURIDICA';
      }
      
      const payload = {
        nome: nomeRelatorio,
        aluguel: { id: this.aluguel.id }
      };

      this.showLoading();
      this.gerarRelatorio(payload)
        .then((resultado) => {
          this.hideLoading();

          switch(resultado.status) {
            case 'SUCESSO':
              window.open(resultado.mensagem, '_blank');
              break;
            case 'FALHA':
              this.$message.warning('Erro ao gerar o Relatório');
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se com o servidor");
        });      
    },

    enviarFichaCadastralEmailHandler(email) {
      let nomeRelatorio;
      if(this.aluguel.locatario.personalidadeJuridica === 'PESSOA_FISICA') {
        nomeRelatorio = 'FICHA_CADASTRAL_LOCACAO';
      } else {
        nomeRelatorio = 'FICHA_CADASTRAL_LOCACAO_JURIDICA';
      }
      
      const payload = {
        nome: nomeRelatorio,
        emailParaEnvio: email,
        aluguel: { id: this.aluguel.id }
      };

      this.showLoading();
      this.enviarRelatorio(payload)
        .then((resultado) => {
          this.hideLoading();

          switch(resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              break;
            case 'FALHA':
              this.$message.warning(resultado.mensagem);
              break;
            case 'ERRO':
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se com o servidor");
        });
    },

    //FORMULARIOS
    selecionarFormulario(formularioSelecionado) {
      if(formularioSelecionado.nomeArquivo !== undefined && formularioSelecionado.nomeArquivo !== null) {
        this.formularioSelecionado = formularioSelecionado;
      } else {
        this.formularioSelecionado = { perguntasFormulario: [] };
      }
    },
    gerarFormulario(formularioSelecionado) {
      if(formularioSelecionado != null) {
        let payload = { id: formularioSelecionado.id };

        this.showLoading();
        this.recuperarPerguntasFormulario(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.finalizarGeracaoFormulario(resultado);
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro.");
        });
      }
    },
    finalizarGeracaoFormulario(resultado) {
      this.formularioSelecionado = resultado.item;
      this.formularioSelecionado["aluguel"] = this.aluguel;
      
      if(this.formularioSelecionado.perguntasFormulario !== undefined) {
        this.exibirDialogPerguntasFormulario();  
      } else {
        this.showLoading();
        this.gerarFormularioAluguel(this.formularioSelecionado)
        .then(response => {
          window.open(response.mensagem, "_blank");
          this.hideLoading();
        }).catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }
    },

    removerDiretorioHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorio(diretorio);
      });
    },
    removerDiretorio(diretorio) {
      let payload = {
        id: diretorio.id,
        tipoFormularios: diretorio.tipoFormularios,
        idObjeto: this.aluguel.id
      };

      this.showLoading();
      this.removerDiretorioAluguel(payload)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERROR":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      });
    },
    recuperarCliente(cliente) {
      let payload = { id: cliente.id };

      this.showLoading();
      this.recuperarClienteAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          if(resultado.status == "SUCESSO") {
            this.$router.push("/alugueis/clientes");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Oops, this is a error message.");
          this.hideLoading();
        });
    },

    gerarResumoContrato() {
      this.showLoading();
      this.gerarResumo({ id: this.aluguel.id })
        .then(response => {
          window.open(response.mensagem, "_blank");
          this.hideLoading();
        }).catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
    },

    //ARQUIVOS
    removerArquivoHandler(arquivo) {
      this.$confirm("Tem certeza que deseja remover este Arquivo?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        let payload = { id: arquivo.id };

        this.showLoading();
        this.removerArquivo(payload)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERROR":
              this.$message.error(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro");
        });
      });
    },
    downloadArquivoHandler(arquivo) {
      window.open(arquivo.path, "_blank");
    },
    exibirDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = true;
    },
    fecharDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = false;
    },
    exibirBotaoRemoverDiretorioArquivo(data) {
      return data.nome !== "Outros";
    },
    selecionarArquivo(arquivoSelecionado) {
      if(arquivoSelecionado !== undefined && arquivoSelecionado.descricao !== null) {
        this.arquivoSelecionado = arquivoSelecionado;
      }
    },
    labelPropriedades(key){
      switch (key) {
        case "usuario":
          return "Usuário";
        case "data":
          return "Envio";
        case "localizacaoFisica":
          return "Observações";    
        case "descricao":
          return "Nome";
        case "extensao":
          return "Extensão do Arquivo"  
        default:
          break;
      }
    },
    removerArquivosHandler(data){
      if(data.descricao){
        this.removerArquivoHandler(data)
      }else{
        this.removerDiretorioArquivosHandler(data)
      }
    },
    removerDiretorioArquivosHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorioArquivo(diretorio);
      });
    },
    removerDiretorioArquivo(diretorio) {
      let payload = { id: diretorio.id, idAluguel: this.aluguel.id};

      this.showLoading();
      this.removerDiretorioArquivos(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    formatarLabelArquivo(arquivo) {
      if(arquivo.descricao != undefined){
        return "normal";
      }
      return "bold";
    },

    formatarIconeTreeArquivo(arquivo) {
      if(arquivo.descricao != undefined) {
        return 'el-icon-document'
      }
      return 'el-icon-folder-opened'
    },
    exibirDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = true;
    },
    fecharDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = false;
    },

    //OBSERVACOES
    exibirObservacao(observacaoSelecionada) {
      this.observacaoSelecionada = observacaoSelecionada;
    },

    alterarObservacao(observacao, column) {
      if(this.aluguel.status === 'ARQUIVADO') { return } 

      if(column.columnKey == "acoes") { return }
      if(!this.permissoes.alterarObservacoes) { return }
      if(this.permissoes.alterarObservacoesSomenteCorretor && observacao.usuario.id !== this.usuarioLogado.id) { return }

      let payload = { id: observacao.id };

      this.showLoading();
      this.recuperarObservacaoAluguel(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.observacaoEmEdicao = resultado.item;
            this.observacaoSelecionada = {};
            this.visibilidadeGravarObservacaoDialog = true;
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },

    removerObservacaoHandler(observacao) {
      this.$confirm("Tem certeza que deseja remover esta Observação?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        let payload = { id: observacao.id };

        this.showLoading();
        this.removerObservacao(payload)
        .then(resultado => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.observacaoSelecionada = {};
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se com o servidor");
        });
      });
    },

    gerarRelatorioObservacao() {
      let payload = { 
        nome: "OBSERVACOES_ALUGUEL",
        aluguel: { id: this.aluguel.id }
      };

      this.showLoading();
      this.gerarRelatorio(payload)
      .then((response) => {
        this.hideLoading();
        switch(response.status) {
          case "SUCESSO":
            window.open(response.mensagem, '_blank');  
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },

    getDescricaoStatus() {
      const tipoAluguelFoiSelecionado = Boolean(this.aluguel.tipoAluguel);
      const tipoGarantiaFoiSelecionado = Boolean(this.aluguel.tipoGarantia);
      const tipoAluguelIsGarantido = this.aluguel.tipoAluguel === 'GARANTIDO';

      const status = this.getLabel(STATUS_CONTRATO_ALUGUEL, this.aluguel.status);

      let descricao = `${status}`;
      
      if (tipoAluguelFoiSelecionado) {
        const tipoGarantia = this.getLabel(TIPO_GARANTIA, this.aluguel.tipoGarantia);
        const tipoAluguel = this.getLabel(TIPO_ALUGUEL, this.aluguel.tipoAluguel);

        if (tipoAluguelIsGarantido) {

          if (tipoGarantiaFoiSelecionado) {
            descricao += ` (${tipoAluguel} por ${tipoGarantia})`;
  
          } else {
            descricao += ` (${tipoAluguel})`;
          }
        } else {
          descricao += ` (${tipoAluguel})`;
        }
      }

      return descricao;
    },

    desfazerTrocaTitularidadeHandler(historico) {
      this.$confirm('Ao confirmar, você irá desfazer a última alteração de titularidade que foi feita no contrato, deseja realmente continuar?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        if(historico.clienteAnterior.id === historico.clienteNovo.id) {
          this.exibirDesfazerTrocaTitularidade(historico);
        } else {
          switch (historico.tipoEntidade) {
            case "PROPRIETARIO":
              this.desfazerTrocaTitularidadeProprietarioHandler(historico);
              break;
            case "LOCATARIO":
              this.desfazerTrocaTitularidadeLocatarioHandler(historico);
              break;
          }
        }
      }).catch(() => {})
    },

    desfazerTrocaTitularidadeProprietarioHandler(historico) {
      this.showLoading();

      this.desfazerTrocaTitularidadeProprietario(historico)
      .then(resposta => {
        switch (resposta.status) {
          case "SUCESSO":
            this.$message.success(resposta.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resposta.mensagem);
            break;
          case "ERRO":
            this.$message.error(resposta.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error("Erro ao comunicar-se com o servidor;");
      }).finally(() => {
        this.hideLoading();
      })
    },

    desfazerTrocaTitularidadeLocatarioHandler(historico) {
      this.showLoading();

      this.desfazerTrocaTitularidadeLocatario(historico)
      .then(resposta => {
        switch (resposta.status) {
          case "SUCESSO":
            this.$message.success(resposta.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resposta.mensagem);
            break;
          case "ERRO":
            this.$message.error(resposta.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Erro ao comunicar-se com o servidor');
      }).finally(() => {
        this.hideLoading();
      })
    },

    //DIALOGS
    exibirAlterarDatasRenovacaoReajuste(){
      this.visibilidadeAlterarReajusteRenovacao = true;
    },
    fecharAlterarDatasRenovacaoReajuste(){
      this.visibilidadeAlterarReajusteRenovacao = false;
    },
    exibirAdicionarLancamentoDialog() {
      this.visibilidadeAdicionarLancamentoDialog = true;
    },
    fecharAdicionarLancamentoDialog() {
      this.visibilidadeAdicionarLancamentoDialog = false;
    },
    exibirAdicionarBoletoDialog(row) {
      if(this.aluguel.status === 'ARQUIVADO') {
        return
      }

      if(!row.id){
        this.boletoAvulsoSelecionado = undefined
      }

      this.visibilidadeAdicionarBoletoDialog = true;
    },
    fecharAdicionarBoletoDialog() {
      this.visibilidadeAdicionarBoletoDialog = false;
    },
    exibirAdicionarDescontoDialog() {
      this.visibilidadeAdicionarDescontoDialog = true;
    },
    fecharAdicionarDescontoDialog() {
      this.visibilidadeAdicionarDescontoDialog = false;
    },
    exibirAlterarRenovacaoDialog() {
      this.visibilidadeAlterarRenovacaoDialog = true;
    },
    fecharAlterarRenovacaoDialog() {
      this.visibilidadeAlterarRenovacaoDialog = false;
    },
    exibirAlterarValorDialog() {
      this.visibilidadeAlterarValorDialog = true;
    },
    fecharAlterarValorDialog() {
      this.visibilidadeAlterarValorDialog = false;
    },
    exibirAlterarTaxaAdmDialog() {
      this.visibilidadeAlterarTaxaAdmDialog = true;
    },
    fecharAlterarTaxaAdmDialog() {
      this.visibilidadeAlterarTaxaAdmDialog = false;
    },
    exibirAlterarCarenciaDialog() {
      this.visibilidadeAlterarCarenciaDialog = true;
    },
    fecharAlterarCarenciaDialog() {
      this.visibilidadeAlterarCarenciaDialog = false;
    },
    exibirProrrogarAluguelDialog() {
      this.$confirm("Ao prorrogar contrato é possível gerar novos recibos, porém a duração do contrato permanece a mesma. Prorrogar um contrato não é a mesma ação de Reajustar ou Renovar.", "Informativo sobre a Prorrogação", {
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.visibilidadeProrrogarAluguelDialog = true;
      }).catch(() => {});
    },
    fecharProrrogarAluguelDialog() {
      this.visibilidadeProrrogarAluguelDialog = false;
    },
    exibirRenovarContratoDialog() {
      this.$confirm("A renovação só deve ser realizada próxima ao fim do contrato. Ocorre uma atualização na duração, periodo de reajuste, valor do aluguel e na multa rescisória. Confira as informações do seu contrato e certifique-se de estar realizando a operação correta.", "Informativo sobre a Renovação", {
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.visibilidadeRenovarContratoDialog = true;
      }).catch(() => {});
    },
    fecharRenovarContratoDialog() {
      this.visibilidadeRenovarContratoDialog = false;
    },
    exibirReajustarAluguelDialog() {
      this.$confirm("O reajuste é a atualização do valor do aluguel cobrado mensalmente e essa ação é realizada de acordo com quantidade de meses em Reajuste do Contrato. Caso o contrato esteja proximo da sua finalização essa operação deve ser cancelada e o contrato deve ser renovado.", "Informativo sobre o Reajuste", {
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.visibilidadeReajustarAluguelDialog = true;
      }).catch(() => {});
    },
    fecharReajustarAluguelDialog() {
      this.visibilidadeReajustarAluguelDialog = false;
    },
    exibirGerarDimobDialog() {
      this.visibilidadeGerarDimobDialog = true;
    },
    fecharGerarDimobDialog() {
      this.visibilidadeGerarDimobDialog = false;
    },
    exibirAlterarVencimentoDialog() {
      this.visibilidadeAlterarVencimentoDialog = true;
    },
    fecharAlterarVencimentoDialog() {
      this.visibilidadeAlterarVencimentoDialog = false;
    },
    exibirResumoFinanceiroDialog() {
      this.visibilidadeResumoFinanceiroDialog = true;
    },
    fecharResumoFinanceiroDialog() {
      this.visibilidadeResumoFinanceiroDialog = false;
    },
    exibirDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = true;
    },
    fecharDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = false;
    },
    exibirDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = true;
    },
    fecharDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = false;
    },
    exibirDialogSelecionarDiretorio() {
      this.visibilidadeSelecionarDiretorioDialog = true;
    },
    fecharDialogSelecionarDiretorio() {
      this.visibilidadeSelecionarDiretorioDialog = false;
    },
    exibirDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = true;
    },
    fecharDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = false;
    },
    exibirDialogGravarCliente() {
      this.visibilidadeGravarClienteDialog = true;
    },
    fecharDialogGravarCliente() {
      this.visibilidadeGravarClienteDialog = false;
    },
    exibirDialogGravarFiador() {
      this.visibilidadeGravarFiadorDialog = true;
    },
    fecharDialogGravarFiador(cliente) {
      if(cliente){
        this.fiadorSelecionado = cliente;
        this.fiadoresDisponiveis = [cliente];
      }
      this.visibilidadeGravarFiadorDialog = false;
    },
    exibirDialogGerarEnviarRelatorio(){
      this.visibilidadeGerarEnviarRelatorioDialog = true;
    },
    fecharDialogGerarEnviarRelatorio(clienteBoleto){
      this.visibilidadeGerarEnviarRelatorioDialog = false;

      if(!clienteBoleto) return

      if(clienteBoleto.geracao === 'PDF'){
        this.gerarLaudoHandler()
      } else {
        this.enviarEmailLaudoHandler(clienteBoleto.email)
      }
    },
    exibirGerarEnviarFichaCadastralDialog() {
      this.visibilidadeGerarEnviarFichaCadastralDialog = true;
    },
    fecharGerarEnviarFichaCadastralDialog(payload) {
      this.visibilidadeGerarEnviarFichaCadastralDialog = false;

      if(!payload) return

      if(payload.geracao === 'PDF') {
        this.gerarFichaCadastralHandler();
      } else {
        this.enviarFichaCadastralEmailHandler(payload.email);
      }
    },
    exibirDesocuparDialog() {
      this.visibilidadeDesocuparDialog = true;
    },
    fecharDesocuparDialog() {
      this.visibilidadeDesocuparDialog = false;
    },
    desocupar() {
      this.visibilidadeDesocuparDialog = false;
      this.pesquisarHandler();
    },

    exibirFinalizarAluguelDialog() {
      this.visibilidadeFinalizarAluguelDialog = true;
    },
    fecharFinalizarAluguelDialog() {
      this.visibilidadeFinalizarAluguelDialog = false;
    },
    finalizar() {
      this.visibilidadeFinalizarAluguelDialog = false;
      this.pesquisarHandler();
    },
    
    exibirGravarObservacaoDialog() {
      this.observacaoEmEdicao = undefined
      this.visibilidadeGravarObservacaoDialog = true;
    },
    fecharGravarObservacaoDialog() {
      this.visibilidadeGravarObservacaoDialog = false;
    },
    exibirSelecionarContaRepasseDialog(contaBancariaRepasse) {
      this.clienteContaRepasse = contaBancariaRepasse.proprietarioBeneficiario
      this.visibilidadeSelecionarContaRepasseDialog = true;
    },
    fecharSelecionarContaRepasseDialog(contaBancaria) {
      if(contaBancaria && contaBancaria.id){
        this.atualizarContasRepasse(contaBancaria)
      }
      this.visibilidadeSelecionarContaRepasseDialog = false;
    },
    exibirSelecionarContaImobiliariaDialog() {
      this.visibilidadeSelecionarContaImobiliariaDialog = true;
    },
    fecharSelecionarContaImobiliariaDialog(contaBancaria) {
      this.aluguel.contaBancariaImobiliaria = contaBancaria
      this.visibilidadeSelecionarContaImobiliariaDialog = false;
    },
    exibirGerarBoletoDialog() { 
      this.visibilidadeGerarBoletoDialog = true 
    },
    fecharGerarBoletoDialog() { 
      this.visibilidadeGerarBoletoDialog = false; 
    },
    exibirGerarBoletosEmAbertoDialog() {
      this.visibilidadeGerarBoletosEmAbertoDialog = true;
    },
    fecharGerarBoletosEmAbertoDialog() {
      this.visibilidadeGerarBoletosEmAbertoDialog = false;
    },
    exibirProrrogarBoletoAvulsoDialog() {
      this.visibilidadeProrrogarBoletoAvulsoDialog = true;
    },
    fecharProrrogarBoletoAvulsoDialog() {
      this.visibilidadeProrrogarBoletoAvulsoDialog = false;
      this.boletoAvulsoSelecionado = undefined;
    },
    exibirTrocaTitularidadeDialog() {
      this.visibilidadeTrocaTitularidadeDialog = true;
    },
    fecharTrocaTitularidadeDialog() {
      this.visibilidadeTrocaTitularidadeDialog = false;
    },
    exibirDesfazerTrocaTitularidade(historico) {
      this.historicoASerDesfeito = historico;
      this.visibilidadeDesfazerTrocaTitularidadeDialog = true;
    },
    fecharDesfazerTrocaTitularidadeDialog() {
      this.visibilidadeDesfazerTrocaTitularidadeDialog = false;
    },
    selecionarBoletoAvulso(row) {
      this.boletoAvulsoSelecionado = { ...row, aluguel: { id: this.aluguel.id } }
    },

    //UTIL
    getLabel(array,item) {
      return Util.getLabel(array,item);
    },
    formatarValor(valor) {
      return Util.formatarValor(valor);
    },
    formatarEnderecoImovel(imovel){
      return Util.formatarLabelImovel(imovel, ESTADOS);
    },
    formatarSelectCliente(cliente){
      return Util.formatarSelectCliente(cliente);
    },
    coresPesquisa(status) {
      switch(status) {
        case "APROVADO":
          return "#2DB748";
        case "PENDENTE":
          return "#4B6EF6";
        case "EM_DESOCUPACAO":
          return "#FF9E29";
        case "FINALIZADO":
          return "#DF1B1B";
        case "ARQUIVADO":
          return "#A1A4A8"
      }
    },
    coresStatusVistorias(status) {
      switch(status) {
        case "CONCLUIDO":
          return "#2DB748";
        case "AGENDADO":
          return "#FF9E29";
        case "CANCELADO":
          return "#DF1B1B";
      }
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    removerConta(contaRepasse){
      this.$confirm("Tem certeza que deseja remover esta Conta de Repasse?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        contaRepasse.contaBancaria = this.auxContaBancaria
      });
    },
    removerDescontoAcordo(row) {
      this.$confirm("Tem certeza que deseja remover este Desconto?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.showLoading()
        this.removerDesconto(row)
        .then((resultado) =>  {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se com o servidor");
        });        
      });
    },
    removerLancamento(row) {
      this.$confirm("Tem certeza que deseja remover este Lançamento?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        row.aluguel = { id: this.aluguel.id }
        this.showLoading()
        this.removerLancamentoFuturo(row)
        .then((resultado) =>  {
          if (resultado.status == "SUCESSO") {
            this.$message.success(resultado.mensagem);
          }
          this.hideLoading()
        }).catch(() => {
          this.$message.error("Não foi possível conectar-se com o servidor");
          this.hideLoading()
        });
      });
    },
    confirmarRemocaoBoletoAvulso(boletoAvulso) {
      this.$confirm("Tem certeza que deseja remover este Boleto Avulso?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      })
        .then(() => {
          if(boletoAvulso.dataRegistro) {
            this.$confirm("Este boleto está registrado e a remoção é definitiva! Inviabilizando qualquer baixa automática, caso ele também não tenha sido cancelado no seu banco.", "Atenção", {
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
              type: "warning"
            }).then(() => {
              this.removerBoletoAvulsoHandler(boletoAvulso);    
            })
            return;
          }
          this.removerBoletoAvulsoHandler(boletoAvulso);
        })
        .catch(() => {});
    },
    confirmarCancelamentoProrrogacaoBoletoAvulso() {
      this.$confirm("Tem certeza de que deseja cancelar a prorrogação deste Boleto Avulso?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.cancelarProrrogacaoBoletoAvulsoHandler();
      }).catch(() => {});
    },
    cancelarProrrogacaoBoletoAvulsoHandler() {
      this.showLoading();

      const boletoAvulso = { id: this.boletoAvulsoSelecionado.id };
      this.cancelarProrrogacaoBoletoAvulso(boletoAvulso).then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case 'SUCESSO':
            this.$message.success(resultado.mensagem);
            break;
          case 'ERRO':
            this.$message.error(resultado.mensagem)
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    removerBoletoAvulsoHandler(boletoAvulso) {
      const boletoAvulsoFoiPago = boletoAvulso.status === 'PAGO';
      if(boletoAvulsoFoiPago) {
        this.$alert(
          'Não é possível remover um Boleto Avulso pago. Por favor, cancele o pagamento e tente novamente',
          'Erro',
          { confirmButtonText: 'OK', type: 'error' }
        );
        return;
      }

      this.showLoading();
      const payload = { id: boletoAvulso.id };

      this.removerBoletoAvulso(payload)
      .then(resultado =>  {
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.boletoAvulsoSelecionado = undefined;
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }
      })
      .catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
      .finally(() => {
        this.hideLoading();
      });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload)
      .then(() => {
        this.loadingUsuarios = false;    
      }).catch(() => {
        this.loadingUsuarios = false;    
      });
    },
    filtrarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString,

      this.loadingClientes = true;
      this.listarClientes(payload)
      .then(() => {
        this.loadingClientes = false;
      }).catch(() => {
        this.loadingClientes = false;    
      });
    },
    filtrarImoveisSelect(queryString) {
      let payload = {
        operacao: "ALUGUEL",
        status: "DISPONIVEL"
      };

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.endereco = queryString,

      this.loadingImoveis = true;
      this.listarImoveis(payload)
      .then(() => {
        this.loadingImoveis = false;
      }).catch(() => {
        this.loadingImoveis = false;
      });
    },
    filtrarFiadoresSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString,

      axios.post(URLS.CLIENTES_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            this.fiadoresDisponiveis = response.data.lista;
            return response.data;
          case "SESSAO_EXPIRADA":
            return this.$store.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if(authResponse.status == "SUCESSO") {
                return this.filtrarFiadoresSelect(queryString)
              }
            }).catch((error) => {
              throw error;
            });
          default:
            this.fiadoresDisponiveis = []
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
    },
    formatarLabelCorretor(comissao) {
      return comissao.corretor === null ||
        comissao.corretor === undefined ||
        comissao.corretor.nome === null ||
        comissao.corretor.nome === undefined
        ? "IMOBILIÁRIA"
        : comissao.corretor.nome;
    },
    formatarLabelFormulario(formulario) {
      if(formulario.nomeArquivo != undefined){
        return 'normal';
      }
      return 'bold';
    },
    formatarIconeTree(formulario) {
      if(formulario.nomeArquivo != undefined) {
        return 'el-icon-document'
      }
      return 'el-icon-folder-opened'
    },
    formatarLabelValor(item) {
      return this.formatarValor(item.valor);
    },
    formatarLabelValorEmAberto(item) {
      return this.formatarValor(item.valorEmAberto);
    },
    formatarLabelValorPago(item) {
      return this.formatarValor(item.valorPago);
    },
    formatarLabelPercentual(item) {
      return item.percentual + '%';
    },
    
    tabClicked(tab) {
      if(tab.name === "logs") {
        this.handleRecuperarLogs();
      }

      if (tab.name === "formularios") {
        this.handleRecuperarFormularios();
      }
    },

    handleRecuperarLogs() {
      const payload = { aluguel: { id: this.aluguel.id }, pagina: -1 };
      this.showLoading();

      this.recuperarLogs(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    handleRecuperarFormularios() {
      const payload = { tipo: "ALUGUEL" };
      this.showLoading();

      this.recuperarFormularios(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    configurarCampoCorretor() {
      this.aluguel.usuario = this.usuarioLogado;

      const usuarioLogadoNotInUsuariosDisponiveis = !this.usuariosDisponiveis.map(usuario => usuario.id)
        .includes(this.usuarioLogado.id);

      if(usuarioLogadoNotInUsuariosDisponiveis) {
        this.usuariosDisponiveis.push(this.usuarioLogado);
      }
    },
    atualizarValores(){
      let contaRepasse
      if(this.aluguel.imovel){
        this.aluguel.valor = this.aluguel.imovel.valor;
        this.aluguel.comissao = this.aluguel.imovel.comissao;
        this.aluguel.comissao1oMes = this.aluguel.imovel.comissao1oMes;
        
        this.aluguel.imovel.proprietariosBeneficiarios.forEach(item => {
          contaRepasse = {proprietarioBeneficiario: item}
          
          contaRepasse.proprietarioBeneficiario.id = item.id;
          contaRepasse.proprietarioBeneficiario.nome = item.nome;
          contaRepasse.contaBancaria = {id: 0};
          this.aluguel.contasBancariasRepasse.push(contaRepasse)
        });
      }
    },
    exibirAlert(titulo, mensagem, type='warning') {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK", type });
    },
    limpar() {
      this.$refs["formAluguel"].resetFields();
    },
    enviar(){
      if(this.dadosPesquisaAluguel) {
        this.pesquisar();
      }
    },

    //VISTORIAS
    exibirVistoria(vistoria) {
      this.vistoriaSelecionada = vistoria;
      this.comodoSelecionado = (this.vistoriaSelecionada.comodos.length > 0 ? this.vistoriaSelecionada.comodos[0] : { imagens: [] });
    },
    selecionarComodo(item) {
      this.comodoSelecionado = item;
    },
    cancelarVistoriaHandler(vistoria) {
      if(vistoria.status === 'CONCLUIDO') {
        this.confirmarCancelamentoVistoriaConcluida(vistoria);
        return;
      }

      this.confirmarCancelamentoVistoria(vistoria);
    },

    confirmarCancelamentoVistoria(vistoria) {
      this.$confirm("Deseja cancelar esta Vistoria?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.cancelarVistoria(vistoria);
      }).catch(() => {});
    },

    retomarVistoriaHandler(vistoria) {
      this.confirmarRetomarVistoria(vistoria);
    },

    confirmarRetomarVistoria(vistoria) {
      this.$confirm("Deseja retomar esta Vistoria?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.retomarVistoriaAluguel(vistoria);
      }).catch(() => {});
    },

    retomarVistoriaAluguel(vistoria) {
      this.showLoading();

      this.retomarVistoria(vistoria)
      .then((resultado) => {
        this.hideLoading();

        this.vistoriaSelecionada = resultado.item.vistorias.filter(item => { return item.id === this.vistoriaSelecionada.id });

        this.$message.success(resultado.mensagem);
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor")
      })
    },

    confirmarCancelamentoVistoriaConcluida(vistoria) {
      this.$confirm("Prezado cliente, o cancelamento dessa vistoria irá impossibilitar que o laudo seja gerado. Recomendamos que salve o laudo antes de prosseguir.", "Atenção", {
        confirmButtonText: "Ok, estou ciente dos riscos",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.confirmarCancelamentoVistoria(vistoria);
      }).catch(() => {});
    },

    cancelarVistoria(vistoria) {
      this.showLoading();

      this.cancelarVistoriaAluguel(vistoria)
      .then((resultado) => {
        this.hideLoading();
        
        this.vistoriaSelecionada = resultado.item.vistorias.filter(item => {return item.id === this.vistoriaSelecionada.id});

        this.$message.success(resultado.mensagem);
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    removerVistoriaHandler(vistoria) {
      this.$confirm("Deseja remover esta Vistoria?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.removerVistoria(vistoria);
      }).catch(() => {});
    },

    removerVistoria(vistoria) {
      this.showLoading();

      this.removerVistoriaAluguel(vistoria)
      .then(resultado => {
        this.$message.success(resultado.mensagem);
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      }).finally(() => {
        this.hideLoading();
      });
    },

    forcarConclusaoVistoriaHandler(vistoria) {
      this.$confirm('Deseja Forçar a Conclusão desta Vistoria?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.forcarConclusaoVistoria(vistoria);
      }).catch(() => {});
    },

    forcarConclusaoVistoria(vistoria) {
      this.showLoading();

      const payload = {
        id: vistoria.id,
      };
      
      this.forcarConclusaoVistoriaAluguel(payload).then(resultado => {
        switch (resultado.status) {
          case 'SUCESSO':
            this.$message.success(resultado.mensagem);
            break;

          case 'ERRO':
            this.$message.error(resultado.mensagem);
            break;
        
          default:
            break;
        }
      }).catch(() => {
        this.$message.error('Não foi possível conectar-se com o servidor');
      }).finally(() => {
        this.hideLoading();
      });
    },

    gerarLaudoHandler() {
      this.payload = {
        vistoria: {
          id: this.vistoriaSelecionada.id
        }
      }

      this.showLoading();
      this.gerarLaudoVistoria(this.payload)
      .then((resultado) =>  {
        this.hideLoading();
        if (resultado.status == "SUCESSO") {
          window.open(resultado.mensagem, "_blank");
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    enviarEmailLaudoHandler(email) {
      this.payload = {
        emailParaEnvio: email,
        vistoria: {
          id: this.vistoriaSelecionada.id,
          tipo: this.vistoriaSelecionada.tipo,
          aluguel: {id: this.aluguel.id}
        }
      }

      this.showLoading();
      this.enviarLaudoVistoria(this.payload)
      .then((resultado) =>  {
        this.hideLoading();
        if (resultado.status == "SUCESSO") {
          this.$message.success("Laudo enviado com sucesso");
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    gerarFormularioVistoriaHandler() {
      const payload = {
        aluguel: this.aluguel,
      };

      this.showLoading();
      this.gerarFormularioVistoria(payload)
        .then((url) => {
          this.hideLoading();
          window.open(url, '_blank');
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se com o servidor");
        });
    },

    botaoForcarConclusaoVistoriaIsVisible(vistoria) {
      return vistoria.status === 'AGENDADO' && this.permissoes.forcarConclusaoVistoria;
    },
    botaoCancelarVistoriaIsVisible(vistoria) {
      return vistoria.status === 'AGENDADO'
        || (vistoria.status === 'CONCLUIDO' && this.permissoes.cancelarVistoria);
    },
    botaoRemoverVistoriaIsVisible(vistoria) {
      return vistoria.status === 'CANCELADO';
    },
    botaoRetomarVistoriaIsVisible(vistoria) {
      return vistoria.status === 'CANCELADO';
    },

    //VISTORIAS - IMAGENS
    imagemClickHandler(indice) {
      this.imagemSelecionada = indice;
    },

    //VISTORIAS - DIALOG
    agendarVistoriaHandler() { this.visibilidadeDialogGravarVistoria = true; },
    fecharGravarVistoriaDialog() { this.visibilidadeDialogGravarVistoria = false; },

    //HELPERS
    formatarFontWeightTreeVistoria(data) {
      if(this.vistoriaSelecionada.comodos.filter((comodo) => { return comodo === data }).length > 0) {
        return 'bold';
      }
      return 'normal';
    },
    formatarCorEstadoItemVistoria(estado) {
      switch(estado) {
        case "NOVO":
          return "#67C23A";
        case "BOM":
          return "#409EFF";
        case "REGULAR":
          return "#E6A23C";
        case "RUIM":
          return "#F56C6C";
        default:
      }
    },
    formatarListaDetalhesItem(item) {
      if(!item.detalhes || item.detalhes.length == 0) { return ""; }

      var texto = " - ";
      for(var indice in item.detalhes) {
        texto += (item.detalhes[indice].nome ? item.detalhes[indice].nome  + ": " : "") + (item.detalhes[indice].descricao ? item.detalhes[indice].descricao + "; " : "");
      }
      if(texto == " - ") {
        texto = "";
      }

      return texto;
    },

    organizarBoletosPorData(boletos) {
      const boletosOrganizados = boletos.sort((a,b) => {

        let data1 = Util.stringParaData(a.dataVencimento),
            data2 = Util.stringParaData(b.dataVencimento);
            
            return data1 - data2;
      });

      return boletosOrganizados
    },

    formatarLinha1EnderecoImovel(imovel) {
      let texto = Util.formatarLinha1EnderecoImovel(imovel);
      if(imovel.complemento && imovel.complemento.trim() !== '' ) {
        texto += ' - ' + imovel.complemento;
      }

      return texto;
    },

    getLabelBanco(item) {
      return Util.getLabel(this.bancos,item);
    },
    getLabelDuracao(aluguel){
      let texto = aluguel.duracao;
      if(aluguel.duracao === 1){ return texto += " mes"
      }else{ return texto += " meses"}
    },
    getLabelCadastro(aluguel){
      return (aluguel === undefined || aluguel.id === 0 ? "Novo Aluguel" : this.util.formatarEnderecoImovelContratoAluguel(aluguel));
    },
    labelReajusteRenova(){
      return this.util.compararDatas(this.aluguel.previsaoFim, this.aluguel.dataReajuste) != 1 ? 'Renovar em:' : 'Reajustar em:'; 
    },
    getDataReajusteRenovacao(){
      return this.util.compararDatas(this.aluguel.previsaoFim, this.aluguel.dataReajuste) != 1 ? this.getdataRenovacao() : this.aluguel.dataReajuste; 
    },
    getdataRenovacao(){
      return this.util.dataParaString(this.util.adicionarDias(this.aluguel.previsaoFim, 1));
    },

    //BOTOES MOBILE
    retrairBotoes(){
      this.hoverAlterarReajuste = false
      this.hoverAlterarAprovado = false
      this.hoverGravar = false
      this.hoverFinalizar = false
      this.hoverDesarquivar = false
      this.hoverDesaprovar = false
      this.hoverAprovar = false 
      this.hoverDesocupar = false 
      this.hoverCancelarDesocupacao = false
      this.hoverRemover = false
      this.hoverCancelarFinalizacao = false
    },
    expandGravar(){
      this.retrairBotoes();
      this.hoverGravar = !this.hoverGravar
    },
    expandFinalizar(){
      this.retrairBotoes();
      this.hoverFinalizar = !this.hoverFinalizar;
    },
    expandirDesarquivar(){
      this.retrairBotoes();
      this.hoverDesarquivar = !this.hoverDesarquivar;
    },
    expandCancelarFinalizacao(){
      this.retrairBotoes();
      this.hoverCancelarFinalizacao = !this.hoverCancelarFinalizacao
    },
    expandDesaprovar(){
      this.retrairBotoes();
      this.hoverDesaprovar = !this.hoverDesaprovar
    },
    expandAprovar(){
      this.retrairBotoes();
      this.hoverAprovar = !this.hoverAprovar
    },
    expandDesocupar(){
      this.retrairBotoes();
      this.hoverDesocupar = !this.hoverDesocupar
    },
    expandCancelarDesocupacao(){
      this.retrairBotoes();
      this.hoverCancelarDesocupacao = !this.hoverCancelarDesocupacao
    },
    expandRemover(){
      this.retrairBotoes();
      this.hoverRemover = !this.hoverRemover
    },
    irParaSecaoNovo(){
      location.href = '#novo_aluguel'
    },
    irParaSecaoAluguel(){
      location.href = '#aluguel'
    }
  }
};